import Homepage from '@/modules/homepage/Homepage';
import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';

const elements = [
  {
    Component: Homepage,
    path: '/'
  }
];

export const RouterProvider = () => {
  return (
    <BrowserRouter>
      <Routes>
        {elements.map(({ Component, path }, idx) => (
          <Route
            key={idx}
            element={
              <React.Suspense fallback={null}>
                <Component />
              </React.Suspense>
            }
            path={path}
          />
        ))}
      </Routes>
    </BrowserRouter>
  );
};
